import React from 'react';
import _ from 'underscore';
import { Link } from '@bingads-webui-campaign/reports-v4-history';
import { isReportTemplateType } from '../actions/shared';
import InlineEditName from '../actions/inline-edit/name';

export default ({
  i18n, ctrLogger, inlineDownloadDuplicate, handleInlineEditSuccess, notifyErrorPipe, permissions,
}) => ({
  key: 'report-name',
  name: i18n.getString(_TL_('Report name')),
  fieldName: 'Name',
  minWidth: 210,
  maxWidth: 350,
  isRowHeader: true,
  isResizable: true,
  sortable: true,
  sortAscendingAriaLabel: 'Sorted A to Z',
  sortDescendingAriaLabel: 'Sorted Z to A',
  onRender: (item) => {
    function onClickReportName(e) {
      if (isReportTemplateType(item.Type)) {
        ctrLogger.click({
          target: 'SavedReport',
          extraData: _.pick(item, 'Id', 'ReportType'),
        });
      } else {
        e.preventDefault();
        ctrLogger.click({
          target: 'SavedInlineDownloadReport',
          extraData: _.pick(item, 'Id', 'Entity'),
        });
        inlineDownloadDuplicate(item);
      }
    }
    return (
      <Link
        className="report-name-link"
        onClick={onClickReportName}
        to={(permissions && permissions.CustomReportBuilder) ?
         `/campaign/vnext/reporting/edit/${item.Id}` : `/campaign/vnext/reports-v4/edit/${item.Id}`}
      >
        {item.Name}
      </Link>
    );
  },
  data: 'string',
  inlineEdit: true,
  onRenderInlineEdit: (e, item, hanelDismiss, cell) => (
    <InlineEditName
      item={item}
      target={cell}
      onDismiss={() => hanelDismiss()}
      onActionSuccess={() => handleInlineEditSuccess()}
      notifyErrorPipe={notifyErrorPipe}
    />
  ),
});
